// LocalStorage / IndexedDB persistence. MVP: LocalStorage only.
// TODO M2: swap for IndexedDB via idb-keyval + Yjs update stream.

import type { AppState, CanvasElement, ExcalidrawFile } from '@extapia/shared';

const KEY = 'excalidraw-extapia:doc:v1';

interface Snapshot {
  elements: CanvasElement[];
  appState: AppState;
}

export const saveLocal = (snap: Snapshot): void => {
  try {
    localStorage.setItem(KEY, JSON.stringify(snap));
  } catch (err) {
    console.warn('saveLocal failed', err);
  }
};

export const loadLocal = (): Snapshot | null => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw) as Snapshot;
  } catch {
    return null;
  }
};

export const clearLocal = (): void => {
  localStorage.removeItem(KEY);
};

// Export .excalidraw (upstream-compatible)
export const toExcalidrawFile = (snap: Snapshot): ExcalidrawFile => ({
  type: 'excalidraw',
  version: 2,
  source: 'https://excalidraw.extapia.com',
  elements: snap.elements.filter((e) => !e.isDeleted),
  appState: {
    viewBackgroundColor: snap.appState.viewBackgroundColor,
    gridSize: snap.appState.gridSize,
  },
  files: {},
});

export const fromExcalidrawFile = (
  file: ExcalidrawFile,
): { elements: CanvasElement[]; appState: Partial<AppState> } => ({
  elements: file.elements,
  appState: file.appState,
});

export const downloadJSON = (data: unknown, filename: string): void => {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const readFile = async (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsText(file);
  });
};
